<div class="grid--center max--height bg--medium-navy">
  <div class="display-column-flex">
    <div>
        <img height="150px" width="200px" src='./logo/pp-logo-horizontal-white.svg' />    
    </div>
      <button mat-button class="primary-button rounded" (click)="redirectIdentityServer()">
        <span>{{ 'App.LogIn' | translate }}</span>
      </button>
  </div>
</div>
